import { useState } from 'react';
import { CertificateTypeClient, CertificateTypeDTO } from '../services/apiClient';
import { API_BASE_URL } from '../config/config';
import axiosInstance from '../services/axiosInstance';

export const useCertificateTypeApi = () => {
    const apiClient = new CertificateTypeClient(API_BASE_URL, axiosInstance);

    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const create = async (data: CertificateTypeDTO) => {
        setIsLoading(true);
        try {
            await apiClient.createCertificateType(data);
        } catch (err: any) {
            setError(err.message || 'Error creating CertificateType');
        } finally {
            setIsLoading(false);
        }
    };

    const edit = async (id: string, data: CertificateTypeDTO) => {
        setIsLoading(true);
        try {
            await apiClient.updateCertificateType(id, data);
        } catch (err: any) {
            setError(err.message || 'Error updating CertificateType');
        } finally {
            setIsLoading(false);
        }
    };

    const getById = async (id: string) => {
        setIsLoading(true);
        try {
            return await apiClient.getCertificateTypeById(id);
        } catch (err: any) {
            setError(err.message || 'Error fetching CertificateType');
        } finally {
            setIsLoading(false);
        }
    };

    const search = async (filters: any) => {
        setIsLoading(true);
        try {
            return await apiClient.searchCertificateTypes(filters);
        } catch (err: any) {
            setError(err.message || 'Error searching CertificateTypes');
        } finally {
            setIsLoading(false);
        }
    };

    const remove = async (id: string) => {
        setIsLoading(true);
        try {
            await apiClient.deleteCertificateType(id);
        } catch (err: any) {
            setError(err.message || 'Error deleting CertificateType');
        } finally {
            setIsLoading(false);
        }
    };

    return { create, edit, getById, search, remove, isLoading, error };
};